<!-- Navbar -->
<nav class="navbar navbar-expand-lg navbar-light" style="background-color: #ad5d56;" role="navigation" aria-label="Navegación principal">
  <div class="container">
    <a routerLink="/" class="navbar-brand d-flex align-items-center">
      <img src="/7.png" alt="velas.ar - Velas Artesanales" class="logo-img">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav" aria-controls="mainNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="mainNav">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center">
        <li class="nav-item"><a class="nav-link" href="#inicio" (click)="navigateToFragment('inicio', $event)">Inicio</a></li>
        <li class="nav-item"><a class="nav-link" href="#productos" (click)="navigateToFragment('productos', $event)">Productos</a></li>
        @if (lineas.length > 0) {
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" id="lineaDropdown" data-bs-toggle="dropdown" aria-expanded="false" (click)="handleDropdownToggle($event)">
              Línea
            </a>
            <ul class="dropdown-menu" aria-labelledby="lineaDropdown">
              @for (linea of lineas; track linea.lineaSlug) {
                <li>
                  <a class="dropdown-item" [routerLink]="['/coleccion', linea.lineaSlug]" (click)="onClickLink()">
                    {{ getNombreSinLinea(linea.nombre) }}
                  </a>
                </li>
              }
            </ul>
          </li>
        }
        <li class="nav-item"><a class="nav-link" href="#nosotros" (click)="navigateToFragment('nosotros', $event)">Nosotros</a></li>
        <li class="nav-item"><a class="nav-link" href="#contacto" (click)="navigateToFragment('contacto', $event)">Contacto</a></li>
        <li class="nav-item ms-lg-3 mt-2 mt-lg-0"><a class="btn btn-sm btn-primary-custom w-100 w-lg-auto" href="https://tienda.velas.ar">Ir a Tienda</a></li>
      </ul>
    </div>
  </div>
</nav>

